var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTagIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tag"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.59517 3.00736L3.772 3.772L3.00736 7.59517C2.99512 7.65638 2.99818 7.71968 3.01627 7.77943C3.03436 7.83918 3.06693 7.89354 3.11107 7.93768L8.06232 12.8889C8.09753 12.9241 8.13934 12.9521 8.18535 12.9711C8.23135 12.9902 8.28066 13 8.33046 13C8.38026 13 8.42957 12.9902 8.47558 12.9711C8.52159 12.9521 8.5634 12.9241 8.59861 12.8889L12.8889 8.59861C12.9241 8.5634 12.9521 8.52159 12.9711 8.47558C12.9902 8.42957 13 8.38026 13 8.33046C13 8.28066 12.9902 8.23135 12.9711 8.18535C12.9521 8.13934 12.9241 8.09753 12.8889 8.06232L7.93768 3.11107C7.89354 3.06693 7.83918 3.03436 7.77943 3.01627C7.71968 2.99818 7.65638 2.99512 7.59517 3.00736Z",
    fill: "#3EFFB3",
    stroke: "#3EFFB3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.25 6C5.66421 6 6 5.66421 6 5.25C6 4.83579 5.66421 4.5 5.25 4.5C4.83579 4.5 4.5 4.83579 4.5 5.25C4.5 5.66421 4.83579 6 5.25 6Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagIcon);
export default __webpack_public_path__ + "static/media/tag-icon.90ab638f82c240384e435cdc795160e4.svg";
export { ForwardRef as ReactComponent };